<template>
    <filters-wrapper :has-active-filters="props.hasActiveFilters" @submit="emit('submit')" @reset="emit('reset')">
        <template v-slot:panel>
            <FilterStatusToggle v-model="filters.active" @update:model-value="emit('submit')" />
        </template>
        <v-form class="table-filters">
            <v-row dense>
                <v-col v-if="props.companies?.length" cols="12" md="3" sm="6">
                    <v-autocomplete
                        v-model="filters.companyId"
                        :items="props.companies"
                        :label="$t('company')"
                        clearable
                        density="compact"
                        variant="outlined"
                        color="primary"
                        data-cy="priority"
                    />
                </v-col>
                <v-col cols="12" md="3" sm="6">
                    <v-text-field
                        v-model="filters.name"
                        :label="$t('name')"
                        density="compact"
                        variant="outlined"
                        color="primary"
                        data-cy="name"
                    />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" md="3" sm="6">
                    <v-autocomplete
                        v-model="filters.role"
                        :items="availablePersonRoles ? availablePersonRoles : useAvailablePersonRoles"
                        :label="$t('role')"
                        clearable
                        density="compact"
                        variant="outlined"
                        color="primary"
                        data-cy="priority"
                    />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" md="3" sm="6">
                    <v-text-field
                        v-model="filters.login"
                        :label="$t('login')"
                        density="compact"
                        variant="outlined"
                        color="primary"
                        data-cy="login"
                    />
                </v-col>
            </v-row>
        </v-form>
    </filters-wrapper>
</template>

<script setup lang="ts">
    import type {UserFiltersType} from '~/utils/types/account/users/types'
    import {initUserFilters} from '~/utils/types/account/users/helpers'
    import type {SelectOptionType} from '~/utils/types/types'

    const props = defineProps<{
        hasActiveFilters: boolean
        companies?: SelectOptionType[]
        availablePersonRoles?: SelectOptionType[]
    }>()
    const filters = defineModel<UserFiltersType>({
        default: initUserFilters(),
    })
    const emit = defineEmits<{
        (e: 'submit' | 'reset'): void
    }>()

    const useAvailablePersonRoles = computed(() => runtimeStore.availablePersonRoles)
</script>
